import { IconDownload, IconFileTypePdf, IconPrinter } from '@tabler/icons-react';

export default function CompressResultCard({
    name,
    originalSize,
    compressedSize,
    reductionPercent,
    downloadLabel,
    printLabel,
    onDownload,
    onPrint,
    // The card is shared with the image tools, so the caller passes the icon of
    // its own category; PDF stays the default.
    Icon = IconFileTypePdf,
    iconClass = 'bg-pdf-cat-tint text-pdf-cat-solid dark:bg-orange-950/30 dark:text-orange-400',
    /**
     * The page's sticky bar carries the main download, so the card keeps only
     * small icon buttons beside the name for fetching one file of several.
     */
    compact = false,
}) {
    const showPrint = typeof onPrint === 'function';
    const showDownload = typeof onDownload === 'function';
    const hasButtons = showPrint || showDownload;

    return (
        <div className="flex min-w-0 animate-[toolSlide_0.4s_cubic-bezier(0.2,0.8,0.25,1)_both] flex-col rounded-xl border border-[#ECE8E4] bg-white p-3 shadow-[0_1px_2px_rgba(28,24,21,0.04)] dark:border-zinc-700 dark:bg-zinc-900">
            <div className={`flex items-start gap-2.5 ${compact || !hasButtons ? '' : 'mb-3'}`}>
                <div className={`flex h-10 w-10 flex-none items-center justify-center rounded-lg ${iconClass}`}>
                    <Icon size={20} stroke={1.7} />
                </div>

                <div className="min-w-0 flex-1 leading-snug">
                    <div
                        className="truncate text-[13px] font-semibold text-[#1C1815] dark:text-zinc-100"
                        title={name}
                    >
                        {name}
                    </div>

                    <div className="mt-1 flex flex-wrap items-center gap-x-1.5 gap-y-1">
                        {originalSize ? (
                            <>
                                <span className="text-[11px] text-[#6B635C] dark:text-zinc-400">{originalSize}</span>
                                <span className="text-[11px] text-[#A8A099] dark:text-zinc-500">→</span>
                            </>
                        ) : null}
                        <span className="text-[11px] font-medium text-[#1E9E5E] dark:text-emerald-400">
                            {compressedSize}
                        </span>
                        {reductionPercent != null ? (
                            <span className="inline-flex rounded-full bg-[#E3F6EC] px-2 py-0.5 text-[10.5px] font-semibold text-[#1E9E5E] dark:bg-emerald-950/30 dark:text-emerald-400">
                                -{reductionPercent}%
                            </span>
                        ) : null}
                    </div>
                </div>

                {compact && hasButtons ? (
                    <div className="flex flex-none items-center gap-1.5">
                        {showPrint ? (
                            <button
                                type="button"
                                onClick={onPrint}
                                title={printLabel}
                                aria-label={printLabel}
                                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[#ECE8E4] bg-[#F7F5F3] text-[#3B6FD9] transition-colors hover:border-blue-200 hover:bg-[#E8F0FE] dark:border-zinc-700 dark:bg-zinc-800 dark:text-blue-400 dark:hover:bg-blue-950/40"
                            >
                                <IconPrinter size={15} stroke={1.8} />
                            </button>
                        ) : null}
                        {showDownload ? (
                            <button
                                type="button"
                                onClick={onDownload}
                                title={downloadLabel}
                                aria-label={downloadLabel}
                                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[#ECE8E4] bg-white text-primary transition-colors hover:border-primary/40 hover:bg-primary-50 dark:border-zinc-700 dark:bg-zinc-900 dark:hover:bg-primary-950/30"
                            >
                                <IconDownload size={15} stroke={1.9} />
                            </button>
                        ) : null}
                    </div>
                ) : null}
            </div>

            {!compact && hasButtons ? (
                <div className="flex items-center gap-2">
                    {showPrint ? (
                        <button
                            type="button"
                            onClick={onPrint}
                            title={printLabel}
                            aria-label={printLabel}
                            className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-xl border border-[#ECE8E4] bg-[#F7F5F3] text-[#3B6FD9] transition-colors hover:border-blue-200 hover:bg-[#E8F0FE] dark:border-zinc-700 dark:bg-zinc-800 dark:text-blue-400 dark:hover:bg-blue-950/40"
                        >
                            <IconPrinter size={17} stroke={1.8} />
                        </button>
                    ) : null}

                    {showDownload ? (
                        <button
                            type="button"
                            onClick={onDownload}
                            className="inline-flex h-10 min-w-0 flex-1 items-center justify-center gap-2 rounded-xl bg-primary px-3 text-[13px] font-semibold text-white transition-colors hover:bg-primary/90"
                        >
                            <span className="truncate">{downloadLabel}</span>
                            <IconDownload size={16} stroke={1.9} className="flex-none" />
                        </button>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
